// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3rH5F","label":"LabeledBox_label__Q7HyU"};